import { Link } from 'gatsby-link';
import React, { ReactNode } from 'react';

// * It uses `gatsby-link` however this component may use other Link alike components of other
// * frameworks such as nextjs.
// * Currently we are working with gatsbyjs.

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
export const PageLink = ({
  children,
  to,
  ...other
}: {
  children: ReactNode;
  to: string;
  [other: string]: any;
}) => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const external = to.startsWith('http');

  // Use Gatsby Link for internal links, and <a> for others
  if (external) {
    return (
      <a href={to} {...other}>
        {children}
      </a>
    );
  }

  return (
    <Link className="clickable" to={to} {...other}>
      {children}
    </Link>
  );
};
